module.exports = __webpack_public_path__ + "static/img/Logo-digitactil.2bc900b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo-digitactil.png
// module id = Slue
// module chunks = 0